module.exports = __webpack_public_path__ + "static/media/2.d648d1e0.png";